import { juntar } from './ui'

/** Só http e https viram link: `javascript:` num href é código, não endereço. */
export function ehEnderecoDeVerdade(url: string | null | undefined): url is string {
  return typeof url === 'string' && /^https?:\/\//i.test(url)
}

/**
 * O nome do anúncio, que abre o anúncio numa aba nova quando o WhatsApp mandou
 * o endereço dele.
 *
 * O endereço vem junto da primeira mensagem de quem clicou no anúncio. Sem
 * ele, o nome fica como texto comum: um link que não leva a lugar nenhum
 * ensina que os links do sistema não funcionam.
 *
 * Segunda tranca do mesmo cadeado: o servidor já recusa endereço que não seja
 * http nem https, e aqui a conferência se repete porque o dado é de fora e
 * este é o ponto em que ele vira link clicável.
 */
export function NomeDoAnuncio({
  titulo,
  url,
  dica,
  className,
}: {
  titulo: string
  url: string | null | undefined
  /** Complemento da dica ao passar o mouse, como a hora em que o lead chegou. */
  dica?: string
  className?: string
}) {
  if (!ehEnderecoDeVerdade(url)) {
    return (
      <span className={juntar('truncate', className)} title={dica}>
        {titulo}
      </span>
    )
  }
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      // Dentro de linha clicável (a tabela "Por anúncio" filtra ao clicar), o
      // clique no nome abre o anúncio e não mexe no filtro.
      onClick={(e) => e.stopPropagation()}
      className={juntar('truncate text-marca underline-offset-2 hover:underline', className)}
      title={dica ? `Abrir o anúncio · ${dica}` : 'Abrir o anúncio'}
    >
      {titulo}
    </a>
  )
}
